import React from 'react';
import {SortableContainer, SortableElement, SortEnd} from "react-sortable-hoc";
import {document} from "../../../models/document";
import {arrayMoveMutable} from 'array-move';

type SortableItemProps = {
  document: document
}

const SortableItem = SortableElement<SortableItemProps>(({document}: SortableItemProps) => (
  <div className="bg-white border p-2 m-1 cursor-pointer d-flex align-items-center">
    <p className="m-0 p-0">
      <i className="fa-solid fa-sort me-3" />
    </p>
    <p className="m-0 p-0">
      {document.label}
      {document.lineBreak && (<i className="fa-solid fa-arrow-turn-down ms-2 text-muted" title="Nouvelle ligne"/>)}
    </p>
  </div>
));

type SortableListProps = {
  documentList: document[],
}

const SortableList = SortableContainer<SortableListProps>(({documentList}: SortableListProps) => {
  return (
    <div>
      {documentList.map((document, index) => (
        <SortableItem key={index} index={index} document={document}/>
      ))}
    </div>
  );
});

type DocumentSortableProps = {
  documents: document[],
}

export const DocumentSortable = ({documents}: DocumentSortableProps) => {
  const onSortEnd = ({oldIndex, newIndex}: SortEnd) => {
    arrayMoveMutable(documents, oldIndex, newIndex);
  };

  return (
    <>
      <div className="col p-2 max-w400px">
        <SortableList documentList={documents} onSortEnd={onSortEnd}/>
      </div>
    </>
  );
}
